export const CancelIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1147_21857)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM13.6667 7.54339L11.3122 9.89794L13.6667 12.2525C14.0586 12.6444 14.0624 13.2759 13.6692 13.6692C13.2787 14.0597 12.6476 14.0618 12.2525 13.6667L9.89794 11.3122L7.54339 13.6667C7.1515 14.0586 6.51995 14.0624 6.1267 13.6692C5.73618 13.2787 5.73408 12.6476 6.12917 12.2525L8.48373 9.89794L6.12917 7.54339C5.73729 7.1515 5.73346 6.51995 6.1267 6.1267C6.51723 5.73618 7.1483 5.73408 7.54339 6.12917L9.89794 8.48373L12.2525 6.12917C12.6444 5.73729 13.2759 5.73346 13.6692 6.1267C14.0597 6.51723 14.0618 7.1483 13.6667 7.54339Z"
          fill="#FF6060"
        />
      </g>
      <defs>
        <clipPath id="clip0_1147_21857">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
export const CheckIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1198_9766)">
        <path
          d="M20 10C20 15.5229 15.5229 20 10 20C4.47714 20 0 15.5229 0 10C0 4.47714 4.47714 0 10 0C15.5229 0 20 4.47714 20 10ZM8.84331 15.2949L16.2627 7.87556C16.5146 7.62363 16.5146 7.21512 16.2627 6.96319L15.3503 6.05081C15.0983 5.79883 14.6898 5.79883 14.4379 6.05081L8.3871 12.1015L5.56214 9.27657C5.3102 9.02464 4.90169 9.02464 4.64972 9.27657L3.73734 10.189C3.4854 10.4409 3.4854 10.8494 3.73734 11.1013L7.93089 15.2949C8.18286 15.5469 8.59133 15.5469 8.84331 15.2949Z"
          fill="#3BB643"
        />
      </g>
      <defs>
        <clipPath id="clip0_1198_9766">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
